<template>
    <v-container >
        <v-row class="ma-0 pa-0 px-4">
            <v-col class="ma-0 pa-0" cols="4">
                <v-list-item class="ma-0 pa-0" two-line>
                    <v-list-item-content>
                        <v-list-item-title><p class="font-weight-bold">{{ $t('Global.Users.userLogin') }}</p></v-list-item-title>
                        <v-list-item-subtitle class="mt-n3">{{ item.userLogin }}</v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>
            </v-col>
            <v-col class="ma-0 pa-0" cols="4">
                <v-list-item class="ma-0 pa-0" two-line>
                    <v-list-item-content>
                        <v-list-item-title><p class="font-weight-bold">{{ $t('Global.Users.firstName') }}</p></v-list-item-title>
                        <v-list-item-subtitle class="mt-n3">{{ item.firstName }}</v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>
            </v-col>
            <v-col class="ma-0 pa-0" cols="4">
                <v-list-item class="ma-0 pa-0" two-line>
                    <v-list-item-content>
                        <v-list-item-title><p class="font-weight-bold">{{ $t('Global.Users.lastName') }}</p></v-list-item-title>
                        <v-list-item-subtitle class="mt-n3">{{ item.lastName }}</v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>
            </v-col>
            <v-col class="ma-0 pa-0" cols="4">
                <v-list-item class="ma-0 pa-0" two-line>
                    <v-list-item-content>
                        <v-list-item-title><p class="font-weight-bold">{{ $t('Global.Users.email') }}</p></v-list-item-title>
                        <v-list-item-subtitle class="mt-n3">{{ item.email }}</v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>
            </v-col>
            <v-col class="ma-0 pa-0" cols="4">
                <v-list-item class="ma-0 pa-0" two-line>
                    <v-list-item-content>
                        <v-list-item-title><p class="font-weight-bold">{{ $t('Global.Users.role') }}</p></v-list-item-title>
                        <v-list-item-subtitle class="mt-n3">{{ getRoleType(item) }}</v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import {mapGetters} from "vuex";

export default {
    name: "UsersExpansion",
    props: {
        item: {
            type: Object
        },
        headers: {
            type: Array
        }
    },
  computed: {
    ...mapGetters(['getDefsRolesTypes']),
  },
  methods: {
    getRoleType(item) {
      return this.getDefsRolesTypes.find((e) => e.roleId === item.roleId)?.roleName
    },
  },
}
</script>
